// NOTE: 案件のポリシー: バックエンド(API)管理+このファイル
import { isAdmin, isMember } from '@/policies/';
var project = {
    index: function () {
        return true;
    },
    show: function () {
        return true;
    },
    create: function (company) {
        return isAdmin(company.user_type) || isMember(company.user_type);
    }
    // update, deleteはバックエンドで管理
};
export default project;
